import { useCallback, useEffect, useState } from "react";

const PROMO_CODE = "SUMMERS";
const PROMO_DISCOUNT = 0.05; // -5%
const USED_KEY = "angle-promo-summers-used";
const APPLIED_KEY = "angle-promo-applied";

export function usePromo() {
  const [appliedCode, setAppliedCode] = useState<string | null>(null);
  const [alreadyUsed, setAlreadyUsed] = useState(false);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setAlreadyUsed(localStorage.getItem(USED_KEY) === "1");
    setAppliedCode(localStorage.getItem(APPLIED_KEY));
    setHydrated(true);
  }, []);

  const applyCode = useCallback((code: string): { ok: boolean; message: string } => {
    const normalized = code.trim().toUpperCase();
    if (normalized !== PROMO_CODE) {
      return { ok: false, message: "Code promo invalide." };
    }
    if (localStorage.getItem(USED_KEY) === "1") {
      return { ok: false, message: "Ce code a déjà été utilisé." };
    }
    localStorage.setItem(APPLIED_KEY, normalized);
    setAppliedCode(normalized);
    return { ok: true, message: "Code appliqué : -5% sur votre commande !" };
  }, []);

  const removeCode = useCallback(() => {
    localStorage.removeItem(APPLIED_KEY);
    setAppliedCode(null);
  }, []);

  // Called after a successful checkout to lock the code permanently.
  const consumeCode = useCallback(() => {
    if (appliedCode) {
      localStorage.setItem(USED_KEY, "1");
      localStorage.removeItem(APPLIED_KEY);
      setAlreadyUsed(true);
      setAppliedCode(null);
    }
  }, [appliedCode]);

  const discountRate = appliedCode === PROMO_CODE ? PROMO_DISCOUNT : 0;

  return {
    appliedCode,
    discountRate,
    alreadyUsed,
    hydrated,
    applyCode,
    removeCode,
    consumeCode,
  };
}
